<template>
    
  <toast position="bottom-right" />

	<div :class="containerClass" @click="onWrapperClick">
        <AppTopBar />
    
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>
        
        <div class="layout-main-container">
  
            <div class="layout-main" style="position:relative">
              <!-- <breadcrumb :home="breadcrumb.menu.home" :model="breadcrumb.menu.items" />  -->
              
              <router-view /> <!-- router-view -->
            </div>
            <AppFooter />
        </div>

		<AppConfig :layoutMode="layoutMode" :layoutColorMode="layoutColorMode" @layout-change="onLayoutChange" @layout-color-change="onLayoutColorChange" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import roles from '@/config/roles'
import Service from '@/services/levante-api/levante-api';

export default {
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
    },
    data() {
        // Calcola lo stato di isAdmin
        const isAdmin = localStorage.getItem('usera') ? (JSON.parse(atob(localStorage.getItem('usera'))).isAdmin == 1) : false
        //console.log('user', JSON.parse(atob(localStorage.getItem('usera'))))
        //console.log('isAdmin', isAdmin)

        // 1. Definisci l'array completo delle voci di menu (items)
        const allMenuItems = [
            {label: 'Home', icon: 'pi pi-fw pi-home', to: '/', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
            {label: 'MindTab', icon: 'pi pi-fw pi-cloud', to: '/mindtab', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
            {label: 'Statistiche', icon: 'pi pi-fw pi-chart-bar', to: '/statistiche', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'],adminOnly: true},
            // Voci senza adminOnly
            {label: 'Calendario', icon: 'pi pi-fw pi-book', to: '/calendario', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
            
            {label: 'Prodotti', icon: 'pi pi-mobile', visibility:[ roles.admin.role],  profiles:['all'], 
                items: [
            // Voci con adminOnly
                {label: 'Depositi', icon: 'pi pi-fw pi-map-marker', to: '/depositi', visibility:[ roles.admin.role], profiles: ['all'], adminOnly: true},
                {label: 'Consegna Merce', icon: 'pi pi-fw pi-shopping-cart', to: '/consegnamerce', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
                {label: 'PreOrdini', icon: 'pi pi-fw pi-euro', to: '/preordini', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
                {label: 'Tipologie Prodotto', icon: 'pi pi-fw pi-tags', to: '/type-prodotto', visibility:[ roles.admin.role], profiles: ['all'], adminOnly: true},
                {label: 'Check Prodotti', icon: 'pi pi-fw pi-euro', to: '/verificaProdotti', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
           
            ]},

            {label: 'Corsi', icon: 'pi pi-mobile', visibility:[ roles.admin.role],  profiles:['all'],       
                items: [
                 {label: 'Presenze', icon:'pi pi-fw pi-users', to:'/attendance-summary',visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
                 {label: 'Calendario Presenze', icon:'pi pi-fw pi-calendar', to:'/monthly-attendance',visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
                 {label: 'Check Corsi', icon: 'pi pi-fw pi-euro', to: '/pagamentiCorsoMese', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
                 {label: 'Prenotazioni Senior', icon: 'pi pi-file', to: '/prenotazioni-senior', visibility:[roles.admin.role], profiles: ['all'], adminOnly: true},
            ]},
            {label: 'Cassa', icon: 'pi pi-mobile', visibility:[ roles.admin.role],  profiles:['all'], 
                items: [
                    {label: 'Pagamenti', icon: 'pi pi-fw pi-euro', to: '/pagamenti', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
                    {label: 'Controllo Corsi', icon: 'pi pi-fw pi-exclamation-triangle', to: '/controllo-corsi', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
                    {label: 'Riepilogo Mensile', icon: 'pi pi-fw pi-chart-line', to: '/monthly-earnings-report', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
                    {label: 'Banca', icon: 'pi pi-fw pi-book', to: '/transactions', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},

                    {label: 'Morosi', icon: 'pi pi-fw pi-euro', to: '/morosi', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
            ]},
            // Voci con adminOnly
            {label: 'Visite', icon: 'pi pi-fw pi-book', to: '/visite', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
            {label: 'Appuntamenti Corsi', icon: 'pi pi-fw pi-calendar-plus', to: '/appuntamenti-corsi', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
            {label: 'Convocazioni', icon: 'pi pi-fw pi-book', to: '/tornei', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all']},
            {label: 'Tesseramenti FIGC', icon: 'pi pi-fw pi-id-card', to: '/figc', visibility:[ roles.admin.role], profiles: ['all'], adminOnly: true},
            {label: 'Richieste prova', icon: 'pi pi-user-plus', to: '/app/richiestaProva', visibility:[roles.admin.role], profiles: ['all'], adminOnly: true},
            {label: 'Richieste di contatto', icon: 'pi pi-book', to: '/attivitaExtra', visibility:[roles.admin.role], profiles: ['all'], adminOnly: true},
            {label: 'Chat', icon: 'pi pi-book', to: '/contact-requests', visibility:[roles.admin.role], profiles: ['all'], adminOnly: true},
            {label: 'Richieste Atleti App', icon: 'pi pi-book', to: '/richiesteApp', visibility:[roles.admin.role], profiles: ['all'], adminOnly: true},
            
            // Voci senza adminOnly
            {label: 'Documenti', icon: 'pi pi-file', to: '/app/verificaDocumenti', visibility:[roles.admin.role], profiles: ['all']},
            
            // Voci con adminOnly
            {label: 'Pulmino', icon: 'pi pi-fw pi-book', to: '/pulmino', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
            
          
            {label: 'Informazioni', icon: 'pi pi-mobile', visibility:[ roles.admin.role],  profiles:['all'], adminOnly: true,
                items: [
            // Voci con adminOnly
                {label: 'Modulistica', icon: 'pi pi-fw pi-book', to: '/modulistica', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
                {label: 'Sponsor', icon: 'pi frw pi-euro', to: '/sponsor', visibility:[ roles.admin.role, roles.agent.role], profiles: ['all'], adminOnly: true},
            ]},
            // Sottomenu 'App' (adminOnly)
            {label: 'App', icon: 'pi pi-mobile', visibility:[ roles.admin.role],  profiles:['all'], adminOnly: true,
                items: [
                    {label: 'Andamento app', icon: 'pi pi-chart-bar', to: '/app/statistiche', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Pagine statiche', icon: 'pi pi-id-card', to: '/app/statiche', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Pagine intro', icon: 'pi pi-id-card', to: '/app/intro', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Banner (Home)', icon: 'pi pi-images', to: '/app/banners', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Pagamenti', icon: 'pi pi-euro', to: '/app/pagamenti', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'News', icon: 'pi pi-calendar-plus', to: '/app/news', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Ultimi accessi', icon: 'pi pi-id-card', to: '/app/logAccessi', visibility:[roles.admin.role], profiles: ['all']},
                ]
            },
            
            // Sottomenu 'Aggiungi' (adminOnly)
            {label: 'Aggiungi', icon: 'pi pi-plus', visibility:[ roles.admin.role],  profiles:['all'], adminOnly: true,
                items: [
                    {label: 'Utente', icon: 'pi pi-user-plus', to: '/crea-utente', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Atleta', icon: 'pi pi-user-plus', to: '/crea-atleta', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Staff', icon: 'pi pi-user-plus', to: '/crea-personale', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Corso', icon: 'pi pi-book', to: '/crea-corso', visibility:[roles.admin.role], profiles: ['all']},
                    {label: 'Iscrizione', icon: 'pi pi-id-card', to: '/crea-iscrizione', visibility:[roles.admin.role], profiles: ['all']},
                ]
            },
        ];

        // 2. Filtra l'array di voci di menu
        const filteredItems = allMenuItems.filter(item => {
            // Se l'elemento non ha 'adminOnly' (o è false), lo includi sempre
            if (!item.adminOnly) {
                return true;
            }
            // Se ha 'adminOnly' true, lo includi solo se isAdmin è true
            return isAdmin;
        });

        // 3. Applica il risultato filtrato alla struttura finale del menu
        const finalMenu = [
            {
                items: filteredItems
            }
        ];
        
        //console.log('Final Menu:', finalMenu);

        return {
            loading: false,
            pageName: '',
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: true,
            mobileMenuActive: false,
            menu : finalMenu, // Usa l'array finalMenu qui
            breadcrumb:{
                menu:{
                    home: {icon: 'pi pi-fw pi-home', to: '/'},
                     items: [
                        {label: 'Dashboard'},
                    ]          
                }
            },
        }
    },
    methods: {
      async updateUnvalidatedDocsCount() {
        const service = new Service(this.$eventBus);
        const res = await service.getUnvalidatedDocumentsCount();
        const count = res.count;
        
        // Find the "Documenti" item and update its badge
        const docItem = this.menu[0].items.find(item => item.label === 'Documenti' || item.to === '/app/verificaDocumenti');
        if (docItem) {
          docItem.badge = count > 0 ? count.toString() : null;
        }
      },
      async updateRichiesteProvaCount() {
        const service = new Service(this.$eventBus);
        const res = await service.getRichiesteProvaCount();
        const count = res.count;
        
        // Find the "Richieste prova" item and update its badge
        const trialItem = this.menu[0].items.find(item => item.label === 'Richieste prova' || item.to === '/app/richiestaProva');
        if (trialItem) {
          trialItem.badge = count > 0 ? count.toString() : null;
        }
      },
      onWrapperClick() {
        if (!this.menuClick) {
          this.overlayMenuActive = false;
          this.mobileMenuActive = false;
        }

        this.menuClick = false;
      },

      onSidebarClick() {
        this.menuClick = true;
      },

      onMenuItemClick(event) {
        if (event.item && !event.item.items) {
            this.overlayMenuActive = false;
            this.mobileMenuActive = false;
        }
      },

      onLayoutChange(layoutMode) {
        this.layoutMode = layoutMode;
      },

      onLayoutColorChange(layoutColorMode) {
        this.layoutColorMode = layoutColorMode;
      },

      addClass(element, className) {
          if (element.classList)
              element.classList.add(className);
          else
              element.className += ' ' + className;
      },

      removeClass(element, className) {
          if (element.classList)
              element.classList.remove(className);
          else
              element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      },

      isDesktop() {
          return window.innerWidth >= 992;
      },

      isSidebarVisible() {
          if (this.isDesktop()) {
              if (this.layoutMode === 'static')
                  return !this.staticMenuInactive;
              else if (this.layoutMode === 'overlay')
                  return this.overlayMenuActive;
          }

          return true;
      }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    created(){
        this.$eventBus.on('page-change', (evt) => {   
            this.breadcrumb.menu.items = [{label: evt.currentRoute.name}]
        })       
        this.$eventBus.on('data-loading', () => { 
            // this.loading = true
        })
        this.$eventBus.on('data-loaded', () => { 
            // this.loading = false
        })
        this.$eventBus.on('data-load-success', (evt) => {
            this.$toast.add({
                severity:'success', 
                summary: 'Successo', 
                detail: `${evt.message}`, 
                life: 4000
            })
            //   this.loading = false
        })     
        this.$eventBus.on('data-load-error', (evt) => {
            this.$toast.add({
                severity:'warn', 
                summary: 'Error Message', 
                detail: `message: ${evt.message} url: ${evt.url}`, 
                life: 4000
            })
            //   this.loading = false
        })
        this.$eventBus.on('menu-toggle', (event) => {
            this.menuClick = true;
            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if(this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }
                    
                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }
            
            event.preventDefault();
        })

        // Initial fetch for document badge
        this.updateUnvalidatedDocsCount();
        this.updateRichiesteProvaCount();
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
                'layout-theme-light': this.$appState.theme.startsWith('saga'),
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
}
</script>

<style lang="scss">
// @import './App.scss';
.p-breadcrumb{
    margin-bottom: 20px;
}
</style>
